import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';
import { HOME_ROUTE, TOOLS, TOOLS_ROUTE } from '../content/tools';

/**
 * Split the tools into two balanced columns so the footer stays three columns
 * wide instead of growing one long list as tools are added.
 */
const half = Math.ceil(TOOLS.length / 2);
const FIRST_COLUMN = TOOLS.slice(0, half);
const SECOND_COLUMN = TOOLS.slice(half);

const Footer: React.FC = () => (
  <footer className="app-footer">
    <Container>
      <div className="app-footer__grid">
        <div className="app-footer__brand">
          <span className="footer-brand">
            <FontAwesomeIcon icon={faBullseye} className="me-2" aria-hidden="true" />
            What Am I Sending
          </span>
          <p className="app-footer__blurb">
            An HTTP request logger for webhook testing, plus a set of encoders, decoders and
            generators that run entirely in your browser.
          </p>
        </div>

        <nav className="app-footer__nav" aria-label="Product">
          <h2 className="app-footer__heading">Product</h2>
          <ul className="footer-links">
            <li>
              <Link to={HOME_ROUTE.path}>Endpoints</Link>
            </li>
            <li>
              <Link to={TOOLS_ROUTE.path}>All tools</Link>
            </li>
          </ul>
        </nav>

        <nav className="app-footer__nav app-footer__nav--tools" aria-label="Tools">
          <h2 className="app-footer__heading">Tools</h2>
          <div className="app-footer__columns">
            {[FIRST_COLUMN, SECOND_COLUMN].map((column, index) => (
              <ul className="footer-links" key={index}>
                {column.map((tool) => (
                  <li key={tool.slug}>
                    <Link to={tool.path}>{tool.navLabel}</Link>
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </nav>
      </div>

      <p className="footer-meta mb-0">
        Captured requests are automatically deleted after 5 days, and an endpoint is deleted
        once it has been idle for 5 days. No signup required.
      </p>
    </Container>
  </footer>
);

export default Footer;
